(ns web3.screens.group
  (:require [web3.i18n :as i]
            [web3.routing.core :as routing]
            [web3.components.card :as card]
            [web3.components.parent :as parent]
            [web3.components.tabs :as tabs]
            [web3.components.widgets :as widgets]
            [web3.components.persisted :as persisted]
            [web3.screens.content :as content]
            [web3.screens.asset :as asset]
            [web3.view :as v]
            [web3.components.h-slider :as h-slider]
            [web3.queries.root :as q-root]
            [web3.queries.asset :as q-asset]
            [reagent.core :as r]
            [web3.components.icons :as icons]
            [web3.backend-stubs :as backend-stubs]
            [web3.utils :as utils]
            [web3.persistence.graphql :as g]
            [web3.modals.forms :as forms]
            [web3.hints.core :as hints]
            [web3.persistence.current-property :as current-property]
            [web3.view.hiccup :as hiccup]))
(defn belongs-to-same-asset-group [input group-name]
  (= group-name (:name (:parent input)   )  )
  )
(defn only-same-group-assets [contents group-name]
  (filter #(belongs-to-same-asset-group % group-name) contents)
  )
(defn group-index [groups group-id]
  (count (take-while #(not= (:id %) group-id) groups)))

(v/defview screen
  {:component-did-update
   (fn []
     (js/setTimeout #(hints/show! [:hints/group.suggested-item]) 200))}
  [{:keys [property-id
           group-id]
    :as props}]
  (let [property (when property-id
                   (q-asset/asset-group-names {:id property-id}))
        {:keys [state]} (r/current-component)
        {:keys [edit?]
         :or {edit? false}} @state
        edit-korks [:edit :group]
        edit? (routing/get-query edit-korks)
        property-asset-groups (get-in property [:entity :assetGroups])
        {{group-name :name
          :keys [assets contents]
          :as group} :entity
         content-loading? :graphql/loading?
         :as query} (q-asset/asset-group {:id group-id})
        min-card-count (max (inc (count assets))
                            (count contents))
        editable? (some-> group
                          :sample
                          not)
        existing-tag-names (set (mapcat (fn [asset]
                                          [(:name (:tag asset))
                                           (:tagName asset)]) assets))
        group-key (some-> group-name (backend-stubs/name->group))
        suggested-tags (when group-name
                         (doall
                          (for [tag-id (some->> group-key
                                                (get backend-stubs/group-suggestions)
                                                (keys))
                                :let [{:as tag
                                       tag-name :name} (-> (q-root/tag {:id tag-id})
                                                           :entity)]
                                :when (not (contains? existing-tag-names tag-name))]
                            tag)))]
    [:div.relative
     {:key "group"}
     [tabs/tab-bar
      {:fixed? true
       :tabs
       (doall (for [{:keys [name id]} property-asset-groups]
                {:key id
                 :href (routing/path-for [:group
                                          :property-id property-id
                                          :group-id id])
                 :label name}))
       :key
       "group-nav"

       :selected
       group-id}]
     [widgets/graphql-state (-> query
                                (assoc :absolute? true
                                       :bg-color "white")
                                (update :style merge {:top (-> tabs/TAB-HEIGHT
                                                               (- 2))
                                                      :z-index 4}))]
     [h-slider/h-slider
      {:key
       "group-items"
       :index
       (group-index property-asset-groups group-id)
       :content/key
       group-id
       :content
       [:div.pad-h-3.pad-bottom-3
        [card/card-grid
         {:min-card-count min-card-count
          :key "group-item-grid"
          :add-card-props (when editable?
                            {:href (routing/path-for :router/form-modal [:add/asset]
                                                     :query (parent/modal-query-data {:mutable? false
                                                                                      :root group-id
                                                                                      :root-type "AssetGroup"}))
                             :label (i/get :i/add-item)})
          :before
          [:div.width-100p.pad-v-3
           [:div.flex-none.flex.items-center.mobile-max
            (if-not edit?
              [:div.pad-h-1.text-category.flex.items-center.margin-right-2
               (str "My " group-name " " (i/get :i/items))]
              [:div.flex-auto.margin-right-2
               [persisted/text-input
                {:label (i/get :i/group-name)
                 :container {:class "width-100p"}
                 :dense? true
                 :persisted-value group-name
                 :validators [:required]
                 :persist-value! (fn [this value opts]
                                   (q-asset/asset-group-update! {:id group-id
                                                                 :name value}
                                                                (merge {:component this}
                                                                       opts)))}]])
            (when editable?
              (widgets/edit-pencil {:on-click #(routing/set-query! edit-korks (not edit?))
                                    :class (when edit? "icon--active")}))]]}
         (doall
          (concat
           (->>   (only-same-group-assets assets  group-name)
                (map #(asset/asset-card-props (assoc % :editable? editable? :edit? edit?))))
           (for [{:keys [id name]} suggested-tags
                 :let [icon-name (get-in backend-stubs/group-suggestions [group-key id])]
                 :when icon-name]
             {:key id
              :label name
              :icon (-> (icons/get icon-name)
                        (hiccup/styles {:height 45}))
              :card-style :recommended
              :class "group-recommended-item"
              :on-click #(do
                           (forms/assoc-field! [:Asset/tagName] name)
                           (routing/nav! (routing/path-for :router/form-modal
                                                           [:add/asset]

                                                           :query
                                                           (parent/modal-query-data {:mutable? false
                                                                                     :root group-id
                                                                                     :root-type "AssetGroup"}))))})))]
        [:div.margin-top-4.margin-left-n3.margin-right-n3
         (when-not content-loading?
           [content/user-contents-by-category
            {:contents contents
             :edit? edit?
             :editable? editable?
             :collapse-empty? true
             :label-prefix group-name
             :add-query (parent/modal-query-data {:root group-id
                                                  :root-type "AssetGroup"
                                                  :traverse-up? false})}])]]}]]))

(v/defview group-create
  {:header {:title (i/get :i/create-group)}
   :component-did-mount
   (fn [this]
     (utils/focus-first-input! this))}
  [{:keys [property-id]
    :or {property-id (current-property/get-id)}}]
  (let [{:keys [state] :as this} (r/current-component)
        {:keys [dirty? value]} @state
        {:keys [graphql/loading? graphql/error]} (g/mutation-state)
        submit! (fn []
                  (when-let [name (utils/some-str (:value @(:state this)))]
                    (->> {:name name
                          :property-id property-id
                          :on-create
                          (fn [{:keys [id] :as group}]
                            (swap! (:state this) assoc :value "")
                            (routing/nav! (routing/path-for
                                            :router/root [:group
                                                          :property-id property-id
                                                          :group-id id]
                                            :router/form-modal nil)))}
                         (parent/create-group! this))))]
    [:div.flex.flex-column.pad-all-3
     [persisted/text-input
      {:value value
       :change-value! #(swap! state assoc :value %)
       :loading? loading?
       :label (i/get :i/group-name)
       :helptext (when error (persisted/format-messages {:error error}))
       :on-blur #(swap! state assoc :dirty? true)
       :dirty? dirty?
       :validators [:required]
       :on-save submit!}]
     [widgets/black-button
      {:on-click submit!
       :class "flex margin-v-2 width-100p"}
      (i/get :add/group.submit)]]))
